'use strict';

var select = exports.select = function select(contentElement, target) {
    var targetedValue = contentElement['@target'];
    if (targetedValue) {
        var foundKey;
        for (var key in targetedValue) {
            if (key.indexOf(target) !== -1) {
                foundKey = key;
                break;
            }
        }
        var targetSpecificValue = foundKey && targetedValue[foundKey];
        if (targetSpecificValue && typeof targetSpecificValue !== 'string') {
            return Object.assign({}, targetedValue.Default, targetSpecificValue);
        }
        contentElement = targetSpecificValue ||
            targetedValue.Default;
    }

    return contentElement;
};

var filter = exports.filter = function filter(value, target) {
    if (value && value['@target']) {
        // do filtering
        return select(value, target);
    } else {
        return copy(value, target);
    }
};

var copy = exports.copy = function copy(src, target) {
    var dest;
    var cval;
    var i;
    if (Array.isArray(src)) {
        dest = [];
        for (i = 0; i < src.length; i++) {
            cval = filter(src[i], target);
            if (cval) {
                dest.push(cval);
            }
        }
    }
    else if (src && typeof src === 'object') {
        dest = {};
        var keys = Object.keys(src);
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var val = src[key];
            cval = filter(val, target);
            if (cval) {
                dest[key] = cval;
            }
        }
    }
    else {
        dest = src;
    }

    return dest;
};
